import { ListItem, ListItemButton, ListItemText, ListItemTextProps, Stack, styled } from '@mui/material';

import { AgentProcessingStatus, ThreadStatus, ThreadVariant } from '../../../../../../Cockpit.types';
import { useCockpitContext } from '../../../../../CockpitContextProvider/CockpitContextProvider.hook';
import { ThreadSummaryText } from '../ThreadSummaryText/ThreadSummaryText';
import { ThreadSummaryTimestamp } from '../ThreadSummaryTimestamp/ThreadSummaryTimestamp';

const StyledListItemText = styled(ListItemText, { shouldForwardProp: (prop) => prop !== 'status' })<
  ListItemTextProps & Pick<AgentSummaryListItemProps, 'status'>
>(({ theme, status }) => ({
  ...(status === ThreadStatus.UNREAD && {
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 8,
      top: 16,
      transform: 'translateY(50%)',
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: theme.palette.info.main,
    },
  }),
  paddingLeft: 8,
}));

const StyledListItemButton = styled(ListItemButton)(({ theme, selected }) => ({
  borderRadius: 8,
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  alignContent: 'flex-start',
  '&:after': {
    display: selected ? 'none' : 'block',
    content: '""',
    position: 'absolute',
    height: 1,
    bottom: 0,
    width: '90%',
    backgroundColor: theme.palette.grey[200],
  },
}));

export interface AgentSummaryListItemProps {
  status: ThreadStatus;
  variant: ThreadVariant;
  summary: string;
  timestamp: Date;
  processingStatus: AgentProcessingStatus;
  isSelected?: boolean;
  targetId: string;
}
export const ThreadSummaryListItem = ({
  summary,
  variant,
  status,
  timestamp,
  isSelected,
  targetId,
}: AgentSummaryListItemProps) => {
  const { openThread } = useCockpitContext();

  return (
    <ListItem disablePadding disableGutters>
      <StyledListItemButton selected={isSelected} onClick={() => openThread(targetId, variant)}>
        <StyledListItemText
          status={status}
          slotProps={{
            primary: {
              paddingBottom: 1,
            },
            secondary: {
              component: 'span',
            },
          }}
          primary={
            <Stack direction="row" gap={1} alignItems="start" justifyContent={'space-between'}>
              <ThreadSummaryText status={status}>{summary}</ThreadSummaryText>
              <ThreadSummaryTimestamp timestamp={timestamp} />
            </Stack>
          }
          // processing status can be added as secondary text in the future. Use <ThreadSummaryProgress /> for it then
        />
      </StyledListItemButton>
    </ListItem>
  );
};
